<template>
    <div class="model-wrap">
        <modelView>
        </modelView>
    </div>
</template>
<script>
import modelView from '@/components/modelView/modelView'
export default {
  data () {
    return {
      currentCom: 'mainView'
    }
  },
  components: {
    modelView
  },
  methods: {
    comChange (key) {
      this.currentCom = ''
      this.$nextTick(() => {
        this.currentCom = key
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/variables.less';
.model-wrap {
    width: 100%;
    height: 100%;
}
</style>
